var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _circle, _circle2, _circle3, _ellipse, _ellipse2, _ellipse3, _path3, _path4, _path5, _path6;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgStructureBankLogo = function SvgStructureBankLogo(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.9166,
    y: 70.834,
    width: 16.6667,
    height: 16.6667,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9166,
    y: 70.834,
    width: 16.6667,
    height: 16.6667,
    rx: 2,
    fill: "#7154D6",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9166,
    y: 70.834,
    width: 16.6667,
    height: 16.6667,
    rx: 2,
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73.4166,
    y: 70.834,
    width: 16.6667,
    height: 16.6667,
    rx: 2,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73.4166,
    y: 70.834,
    width: 16.6667,
    height: 16.6667,
    rx: 2,
    fill: "#7154D6",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 73.4166,
    y: 70.834,
    width: 16.6667,
    height: 16.6667,
    rx: 2,
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8333 50H27.5833C22.981 50 19.25 53.731 19.25 58.3333V70.8333",
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1666 50H73.4166C78.019 50 81.75 53.731 81.75 58.3333V70.8333",
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 79.1673,
    r: 8.33333,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 79.1673,
    r: 8.33333,
    fill: "#7154D6",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 79.1673,
    r: 8.33333,
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.5,
    cy: 20.8333,
    rx: 8.33333,
    ry: 8.33333,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.5,
    cy: 20.8333,
    rx: 8.33333,
    ry: 8.33333,
    fill: "#7154D6",
    fillOpacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.5,
    cy: 20.8333,
    rx: 8.33333,
    ry: 8.33333,
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 70.8327V66.666",
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 29.166V33.3327",
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5031 43.75L50.497 56.25",
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2501 49.9963L56.7501 50.0024",
    stroke: "#7154D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStructureBankLogo, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };